import { Bar } from "react-chartjs-2";
import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale);

const LineChart = ({ labels, data }) => {
  const chartProps = {
    labels: labels,
    datasets: data,
  };

  return <Bar data={chartProps} />;
};

export default React.memo(LineChart);
